import script from "./BaseView.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseView.vue?vue&type=script&setup=true&lang=ts"

import "./BaseView.vue?vue&type=style&index=0&id=7c03eefe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c03eefe"]])

export default __exports__